import React, { useState, useEffect, useRef } from "react";
import { CiLocationOn, CiSearch } from "react-icons/ci";
import JobList from "./JobList";
import { useLocation, useNavigate } from "react-router-dom";
import { useStores } from "../../store";
import { apiPostPut } from "../../api/api_methods";
import Loader from "../reusble_components/loader";
import { PiSuitcaseSimple } from "react-icons/pi";
import { MdOutlineCurrencyRupee } from "react-icons/md";
import { LuFileCog } from "react-icons/lu";
import ResponsiveHeader from "../reusble_components/labels3/responsiveHeader";

// Debounce Hook
const useDebounce = (value, delay) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
};

const Internship = () => {
  const { RecuiterStore } = useStores();
  const [loader, setLoader] = useState(false);
  const [filter, setFilter] = useState({
    salary: "",
    search: "",
    experience: "",
    location: "",
    workMode: "",
    jobMode: "",
    jobType: "",
  });
  const location = useLocation();
  const navigate = useNavigate();
  const scrollRef = useRef(null);

  // Debounce search term to avoid frequent API calls
  const debouncedSearch = useDebounce(filter.search, 500);

  // Function to update filter dynamically
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    console.log(name, value);
    setFilter((prevFilter) => ({
      ...prevFilter,
      [name]: value,
    }));
  };

  const fetchFilteredData = async () => {
    setLoader(true);
    try {
      const response = await apiPostPut(filter, "/job-post/job-posts", "POST");
      if (response.status === 200 && response.body.success) {
        RecuiterStore.setJobPosts(response.body.data);
        setLoader(false);
      } else {
        console.error("Error fetching job data:", response.body.message);
        setLoader(false);
      }
    } catch (error) {
      console.error("Error fetching job data:", error);
      setLoader(false);
    }
  };

  // Trigger filter fetch when the user presses Enter
  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      fetchFilteredData();
    }
  };

  // Scroll to top of the job list on filter change or route change
  useEffect(() => {
    scrollRef.current.scrollIntoView();
  }, [location]);

  // Reset all filters
  const handleResetFilters = () => {
    setFilter({
      salary: "",
      search: "",
      experience: "",
      location: "",
      workMode: "",
      jobMode: "",
      jobType: "",
    });

    const skip = 0 * 10;
    const body = { skip, limit: 10 };
    RecuiterStore.fetchJobPosts(body);
  };

  // useEffect(() => {
  //   navigate("/dashboard/jobinternship?page=0");
  // }, []);

  return (
    <div className="mt-4">
      <Loader loader={loader} />
      <div className="gil-reg" id="jobsTopview" ref={scrollRef}>
        <div className="w-[90%] md:w-[97%] mx-auto md:mt-4 mt-14">
          <ResponsiveHeader
            title="Jobs"
            showDropdown={false}
            showButton={false}
            handleInputChange={(e) => {
              setFilter({ ...filter, search: e.target.value });
            }}
            name="search"
            // onChange={handleFilterChange}
            onKeyPress={handleKeyPress}
            addfilter={true}
          />
        </div>

        <div className="flex-col gap-y-4 w-[99%] mt-6 py-6 mx-auto  bg-black rounded-lg p-6 px-5 text-primary md:flex lg:flex hidden">
          <div className="flex flex-row items-center justify-between">
            <h1 className="text-primary text-xl">Filter</h1>
            <h2
              className="text-primary justify-end ml-auto text-xs cursor-pointer"
              onClick={handleResetFilters}
            >
              Reset All
            </h2>
          </div>

          {/* Filter Inputs */}
          <div className="flex flex-row gap-5">
            {/* Search Filter */}
            <div className="flex flex-row items-center w-60">
              <CiSearch className="text-primary text-lg ml-2 mr-1" />
              <input
                type="text"
                name="search"
                value={filter.search}
                onChange={handleFilterChange}
                onKeyPress={handleKeyPress}
                placeholder="Search by keyword"
                className="ml-1 w-full bg-transparent border-none focus:outline-none"
              />
              {/* <IoIosArrowDropdown className="text-gray-500 ml-auto mr-4 mt-1" /> */}
            </div>

            {/* Work Mode Filter */}
            <div className="flex flex-row items-center relative text-white border-l-2 w-60 border-gray-500 pl-2">
              <PiSuitcaseSimple className="text-primary text-base mt-1 ml-2 mt-0.5 mr-1" />
              <select
                name="workMode"
                value={filter.workMode}
                onChange={handleFilterChange}
                className="bg-transparent w-full border-none focus:outline-none "
              >
                <option value="" className="text-black">
                  Work Mode
                </option>
                <option value="workFromHome" className="text-black">
                  Work From Home
                </option>
                <option value="workFromOffice" className="text-black">
                  Work From Office
                </option>
                <option value="hybrid" className="text-black">
                  Hybrid
                </option>
              </select>
              {/* <IoIosArrowDropdown className="text-gray-500 ml-auto mr-4 mt-1" /> */}
            </div>

            {/* Location Filter */}
            <div className="flex flex-row items-center w-60 text-white border-l-2 border-gray-500 pl-2">
              <CiLocationOn className="text-primary text-lg ml-2 mr-1" />
              <input
                type="text"
                name="location"
                value={filter.location}
                onChange={handleFilterChange}
                placeholder="Location"
                className="ml-1 w-full bg-transparent border-none focus:outline-none"
              />
              {/* <IoIosArrowDropdown className="text-gray-500 ml-auto mr-4 mt-1" /> */}
            </div>

            {/* Job Type Filter */}
            <div className="flex flex-row items-center w-60 text-white border-l-2 border-gray-500 pl-2">
              <LuFileCog className="text-primary text-lg ml-2 mr-1" />
              {/* <input
                type="text"
                name="jobType"
                value={filter.jobType}
                onChange={handleFilterChange}
                placeholder="Job Type"
                className="ml-1 w-full bg-transparent border-none focus:outline-none"
              /> */}
              <select
                name="jobType"
                id=""
                className="bg-transparent w-full border-none focus:outline-none"
                value={filter.jobType}
                onChange={handleFilterChange}
              >
                <option value="" className="text-black">
                  Job Type
                </option>
                <option value="internship" className="text-black">
                  Internship
                </option>
                <option value="contract" className="text-black">
                  Contract
                </option>
                <option value="fulltime" className="text-black">
                  Full time
                </option>
              </select>
              {/* <IoIosArrowDropdown className="text-gray-500 ml-auto mr-4 mt-1" /> */}
            </div>

            {/* Salary Range Filter */}
            <div className="flex flex-row items-center w-60 text-white border-l-2 border-gray-500 pl-2">
              <MdOutlineCurrencyRupee className="text-primary text-lg ml-2 mr-1" />
              <input
                type="number"
                name="salary"
                value={filter.salary}
                onChange={handleFilterChange}
                placeholder="Salary Range"
                className="ml-1 w-full bg-transparent border-none focus:outline-none"
              />
              {/* <IoIosArrowDropdown className="text-gray-500 ml-auto mr-4 mt-1" /> */}
            </div>
          </div>

          <button
            className="bg-primary w-fit ml-auto px-5 text-white cursor-pointer py-2 rounded-lg"
            onClick={fetchFilteredData}
          >
            Submit
          </button>
        </div>

        <div>
          <div className="m-4 mt-8 md:w-full">
            <JobList scrollRef={scrollRef} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Internship;
